import { useQuery } from '@tanstack/react-query'
import { axiosGet } from 'Redux/axiosHelper'
import {
  LeaguePlayerParams,
  LeaguePlayersResp,
  ManageLeagueMentor,
} from 'types/league/leagueManage'

export type {
  LeaguePlayerParams,
  LeaguePlayerParticipant,
  LeaguePlayersResp,
  ManageLeagueMentor,
} from 'types/league/leagueManage'

const getLeaguePlayers = async (
  leagueId: string,
  params?: LeaguePlayerParams,
) => {
  const response = await axiosGet(`v1/manage-league/${leagueId}/players`, params)
  return response.data
}

export const useGetLeaguePlayers = (
  leagueId: string,
  params?: LeaguePlayerParams,
) => {
  return useQuery<LeaguePlayersResp>(
    ['manage-league-players', leagueId, params],
    () => getLeaguePlayers(leagueId, params),
    { enabled: !!leagueId },
  )
}

const getManageLeague = async (leagueId: string) => {
  const response = await axiosGet(`v1/manage-league/${leagueId}`)
  return response.data
}

export const useGetManageLeague = (leagueId: string) => {
  return useQuery(
    ['manage-league', leagueId],
    () => getManageLeague(leagueId),
    { enabled: !!leagueId },
  )
}

const getLeagueAssignedMentors = async (leagueId: string) => {
  const response = await axiosGet(`v1/league/${leagueId}/assigned-mentors`)
  return response.data
}

export const useGetLeagueAssignedMentors = (leagueId: string) => {
  return useQuery<ManageLeagueMentor[]>(
    ['league-assigned-mentors', leagueId],
    () => getLeagueAssignedMentors(leagueId),
    { enabled: !!leagueId },
  )
}
